import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, Validators } from '@angular/forms';


import 'rxjs';
declare var $:any;

@Component({
  selector: 'app-blog-article',
  templateUrl: './blog-article.component.html',
  styleUrls: ['./blog-article.component.scss']
})
export class BlogArticleComponent implements OnInit {

  blogForm;

  title = 'Realtors, Incentives used to close dealswith home buyers';
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{0,2}$";

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    $('[data-toggle="tooltip"]').tooltip();

    this.blogForm = this.formBuilder.group({
      yourName: ['', [Validators.required]],
      email: ['', [Validators.required]],
      comment: ['', [Validators.required]],
    });
  }

  blogObj = {
    remember: 1,
  };
  status = {
    type: '',
    message: '',
    sending: false
  };

  blogArticleForm(form) {
    let payload, endpoint, headers;

    //endpoint = 'http://www.benutech.com/';
    // headers = new HttpHeaders().set('Authorization', 'auth-token');

    if (form.invalid) {
      this.status = {
        type: 'error',
        sending: false,
        message: 'please correct the red marked fields first.'
      };
      return;
    }

    //this.status.sending = true;

  }

  onSubmit() {
    console.log(this.blogForm.value);
  }

}




// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/pages/blog/blog-article/blog-article.component.ts